'use client';
import { ShieldCheckIcon, TruckIcon, CurrencyDollarIcon, ClockIcon } from '@heroicons/react/24/outline';

const features = [
    {
        title: 'Safe & Secure Services',
        description: 'Your cargo safety is our top priority. We ensure secure handling and transportation throughout the journey.',
        icon: ShieldCheckIcon
    },
    {
        title: 'Fast & On-time Delivery',
        description: 'We understand the importance of timely delivery and maintain strict adherence to delivery schedules.',
        icon: ClockIcon
    },
    {
        title: 'Competitive Rates',
        description: 'Get the best value for your money with our competitive pricing and transparent cost structure.',
        icon: CurrencyDollarIcon
    },
    {
        title: 'Global Reach',
        description: 'Our extensive network enables us to deliver your cargo anywhere in the world efficiently.',
        icon: TruckIcon
    }
];

const ServiceFeatures = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <div className="inline-block px-4 py-2 bg-[#29abe2] bg-opacity-10 rounded-full mb-4">
                        <span className="text-[#29abe2] font-semibold">Why Choose Us</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        We Deliver Your Goods Fast & Secure
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Experience reliable and efficient logistics services with our expert team and modern infrastructure
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <div 
                            key={index} 
                            className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300"
                        >
                            <div className="inline-flex items-center justify-center h-16 w-16 rounded-lg bg-[#29abe2] bg-opacity-10 mb-6">
                                <feature.icon className="h-8 w-8 text-[#29abe2]" />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-3">
                                {feature.title}
                            </h3>
                            <p className="text-gray-600">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <button className="bg-[#29abe2] text-white px-8 py-4 rounded-lg hover:bg-[#1d8ab3] transition duration-300 text-lg font-medium">
                        Contact Us Now
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ServiceFeatures; 